module.exports = __webpack_public_path__ + "img/ic_factoring.fb061563.svg";